import React from 'react';
import '../assets/welcome.scss';
import checksign_icon from 'src/images/icon/checksign_icon.png';
import doc_icon from 'src/images/icon/doc_icon.png';
import market_icon from 'src/images/icon/market_icon.png'
import user_icon from 'src/images/icon/user_icon.png'
import house_icon from 'src/images/icon/house_icon.png'
import wallet_icon from 'src/images/icon/wallet_icon.png'
import mobile_icon from 'src/images/icon/mobile_icon.png'
import {HOME_LOCATION_PATH} from "src/constants/Steps";

interface WelcomePageProps {
    onGetStarted?: () => void;
}

const WelcomePage: React.FC<WelcomePageProps> = ({ onGetStarted }) => {
    const handleGetStarted = () => {
        if (onGetStarted) {
            onGetStarted();
        } else {
            window.location.href = HOME_LOCATION_PATH;
        }
    };

    return (
        <>
                <div className="heading-section">
                    <h1>
                        <span className="welcome-heading">Welcome to </span>
                        <span className="started">Amazon Autos</span>
                    </h1>
                    <p className="welcome-text">We’re excited to help grow your business on the world’s biggest online retail site.</p>
                    <button className="get-started-button" onClick={handleGetStarted}>Get started</button>
                </div>
                
                <div className="content-section">
                    <div className="main-content-box">
                        <div className="info-section">
                            <p className="info-intro">Before you can register, we’ll need some information first:</p>
                            
                            <div className="step">
                                <div className="step-icon">
                                    <img className="checksign-icon" src={checksign_icon}/>
                                </div>
                                <div className="step-content">
                                    <div className="step-title">1. Dealership information (5-15 min)</div>
                                    <p className="step-description">You’ll fill out your dealership’s contact, business, and software information so we can get your account set up correctly on Amazon Autos.</p>
                                </div>
                            </div>
                            
                            <div className="step">
                                <div className="step-icon">
                                    <img className="doc-icon" src={doc_icon}/>
                                </div>
                                <div className="step-content">
                                    <div className="step-title">2. Review & sign contracts (5-10 min)</div>
                                    <p className="step-description">These contracts are for both Amazon and our third-party partners, and are required for Seller Central registration. <strong>If you don’t have the authority to sign legal documents for your dealership, please have an authorized person sign and submit these contracts.</strong></p>
                                </div>
                            </div>
                            
                            <div className="step">
                                <div className="step-icon">
                                    <img className="market-icon" src={market_icon}/>
                                </div>
                                <div className="step-content">
                                    <div className="step-title">3. Register with Amazon Seller Central (~2.5 hrs)</div>
                                    <p className="step-description">Once we verify your information, you’ll get access to register for Amazon Seller Central. Seller Central is where your dealership will manage your business and track your performance on Amazon Autos.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    );
};

export default WelcomePage;
